/**
 * A marca gerada por `pnpm --filter @eldrun/assets brand` em `assets/brand/` (ADR 0021). Os endereços
 * usam `new URL(…, import.meta.url)` com o caminho escrito por extenso: é o que o Vite reconhece para
 * copiar o arquivo para o build com hash.
 */
export const LOGO_SIZE = { width: 1448, height: 1086 } as const;
export const LOGO_WIDTHS = [480, 960, 1440] as const;
export const EMBLEM_SIZES = [32, 180, 512] as const;

export const logoHeight = (width: number): number => Math.round((width * LOGO_SIZE.height) / LOGO_SIZE.width);

export interface BrandUrls {
  readonly logo: { readonly avif: string; readonly webp: string; readonly fallback: string };
  readonly emblem: Readonly<Record<(typeof EMBLEM_SIZES)[number], string>>;
}

/** Os `srcset` do logo (AVIF e WebP, 480/960/1440 w) e os emblemas quadrados. */
export function brandUrls(): BrandUrls {
  const u = (url: URL) => url.href;
  const logo480avif = u(new URL("../assets/brand/logo-480.avif", import.meta.url));
  const logo960avif = u(new URL("../assets/brand/logo-960.avif", import.meta.url));
  const logo1440avif = u(new URL("../assets/brand/logo-1440.avif", import.meta.url));
  const logo480webp = u(new URL("../assets/brand/logo-480.webp", import.meta.url));
  const logo960webp = u(new URL("../assets/brand/logo-960.webp", import.meta.url));
  const logo1440webp = u(new URL("../assets/brand/logo-1440.webp", import.meta.url));
  return {
    logo: {
      avif: `${logo480avif} 480w, ${logo960avif} 960w, ${logo1440avif} 1440w`,
      webp: `${logo480webp} 480w, ${logo960webp} 960w, ${logo1440webp} 1440w`,
      fallback: logo960webp,
    },
    emblem: {
      32: u(new URL("../assets/brand/emblem-32.png", import.meta.url)),
      180: u(new URL("../assets/brand/emblem-180.png", import.meta.url)),
      512: u(new URL("../assets/brand/emblem-512.png", import.meta.url)),
    },
  };
}
